import { render, staticRenderFns } from "./videoTitle.vue?vue&type=template&id=3cdd9080&scoped=true&"
import script from "./videoTitle.vue?vue&type=script&lang=ts&"
export * from "./videoTitle.vue?vue&type=script&lang=ts&"
import style0 from "./videoTitle.vue?vue&type=style&index=0&id=3cdd9080&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdd9080",
  null
  
)

export default component.exports